<template>
  <div id="appId">
     <div class="tab-bar-zc">

      <div class="home"  @mouseenter="enters(4)"
           @mouseleave="leaver(4)" @click = "changeToEnglish" >
        <router-link style="color: white" to="/chineseHome">中文</router-link>
        <div v-show="switchNice[4].arrys" class="divLine-ch" ></div>
      </div>

      <div class="home"  @mouseenter="enters(5)"
           @mouseleave="leaver(5)" @click = "changeToChinese">
        <router-link style="color: white" to="/englishHome">English</router-link>
        <div v-show="switchNice[5].arrys" class="divLine-en" ></div>
      </div>

     </div>
    <div class="tab-bar-ch"  v-show = "flagech">
      <div class="home"  @mouseenter="enters(0)"
           @mouseleave="leaver(0)" >
        <router-link style="color: white" to="/chineseHome">首页</router-link>
        <div v-show="switchNice[0].arrys" class="divLine" ></div>
      </div>
      <div class="about" @mouseenter="enters(1)"
           @mouseleave="leaver(1)" >
        <router-link style="color: white" to="/chineseAbout">公司简介</router-link>
        <div v-show="switchNice[1].arrys" class="divLineAbout" ></div>
      </div>
      <div class="cooperation" @mouseenter="enters(2)"
           @mouseleave="leaver(2)">
        <router-link style="color: white" to="/chineseCooperation">合作方式</router-link>
        <div v-show="switchNice[2].arrys" class="divLineAbout" ></div>
      </div>
      <div class="software" @mouseenter="enters(3)"
           @mouseleave="leaver(3)">
        <router-link style="color: white" to="/chineseSoftware">应用软件</router-link>
        <div v-show="switchNice[3].arrys" class="divLineAbout" ></div>
      </div>
    </div>

    <div class="tab-bar-en"  v-show = "flageen">
      <div class="home-en"  @mouseenter="enters(0)"
           @mouseleave="leaver(0)" >
        <router-link style="color: white" to="/englishHome">home</router-link>
        <div v-show="switchNice[0].arrys" class="divLine-en" ></div>
      </div>
      <div class="about-en" @mouseenter="enters(1)"
           @mouseleave="leaver(1)" >
        <router-link style="color: white" to="/englishAbout">Company Profile</router-link>
        <div v-show="switchNice[1].arrys" class="divLineAbout-en" ></div>
      </div>
      <div class="cooperation-en" @mouseenter="enters(2)"
           @mouseleave="leaver(2)">
        <router-link style="color: white" to="/englishCooperation">cooperation method</router-link>
        <div v-show="switchNice[2].arrys" class="divLinecooperation-en" ></div>
      </div>
      <div class="software-en" @mouseenter="enters(3)"
           @mouseleave="leaver(3)">
        <router-link style="color: white" to="/englishSoftware">application</router-link>
        <div v-show="switchNice[3].arrys" class="divLinesoftware-en" ></div>
      </div>
    </div>
    <router-view/>

  </div>

</template>

<script>
export default {
  name: 'App',
  data(){
    return{


      flagech:true,
      flageen:false,

      switchNice: [
        //这绑定了上面V-show,
        {
          arrys: false
        },
        {
          arrys: false
        },
        {
          arrys: false
        }
        ,
        {
          arrys: false
        }
        ,
        {
          arrys: false
        },
        {
          arrys: false
        },
        {
          arrys: false
        }
      ]

    }

  },
  comments:{
    path:'/home'
  },
  methods:{

    
    enters(index) {
      console.log("进入")
      this.switchNice[index].arrys = true; //这里的先后顺序如果写反了 就会一直闪，这是根据上面那个思路写的，
    },
    leaver(index) {
      console.log("离开")
      this.switchNice[index].arrys = false; //移出时也一样，先B消失 再出现A。
    },
    changeToEnglish(){
      console.log("进入")
      
    },
    changeToEnglish(){
      
      this.flagech=true
      this.flageen=false
      console.log(this.flagech)
    },
    changeToChinese(){
      this.flageen=true
      this.flagech=false
      console.log(this.flageen)
    }
  }
}
</script>

<style>
@import "./assets/css/base.css";
  .tab-bar-en{
    position: absolute;
    z-index: 1000;
    right: 20px;
    top:10px;
    justify-content:space-between;
  }

.tab-bar-zc{

   position: absolute;
    z-index: 1000;
    left: 20px;
    top:10px;
    justify-content:space-between;

}
.tab-bar-ch{
    position: absolute;
    z-index: 1000;
    right: 20px;
    top:10px;
    justify-content:space-between;
}
.divLine{
  width: 4rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}
.divLine-ch{

  width: 2rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}

.divLine-en{

  width: 2rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}
.divLineAbout{
  width: 4rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}
  #appId{
    z-index: 1000;
  }
  .home{
    float: left;
    display: inline;
    z-index: 1000;
    min-width: 3rem;
  }
.about{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 85px;
}


.cooperation{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 5rem;
 }

.software{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 5rem;
}



.home-en{
    float: left;
    display: inline;
    z-index: 1000;
    min-width: 3rem;
  }
.about-en{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 85px;
  margin: 0 8px;
  display: inline-block;

}


.cooperation-en{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 5rem;
  margin: 0 8px;
  display: inline-block;

 }

.software-en{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 5rem;
  margin: 0 8px;
  display: inline-block;
 
}



.Tianmao{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 5rem;
}
a {
  text-decoration: none;
}
.part5{
  background-color: black;
  text-align: center;
}


.divLine-en{
  width: 3rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}


.divLineAbout-en{
  width: 8rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}

.divLinecooperation-en{
  width: 10rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}

.divLinesoftware-en{
  width: 5rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue